import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const useInViewOnce = (threshold = 0.15) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, inView];
};

export const MaskedLines = ({ lines, lineClassName = "", delay = 0, immediate = false }) => {
  const [ref, inView] = useInViewOnce(0.1);
  const show = immediate || inView;
  return (
    <span ref={ref} className="block">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={show ? { y: 0 } : { y: "115%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const ChapterTag = ({ index, label, dark = false }) => (
  <FadeUp className="flex items-center gap-4">
    <span className="font-display italic text-gold text-xl leading-none">{index}</span>
    <span className="h-px w-10 bg-gold/70" />
    <span className={`text-[11px] tracking-[0.32em] uppercase font-bold ${dark ? "text-ivory/60" : "text-stone2"}`}>
      {label}
    </span>
  </FadeUp>
);
